// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5f3f5514","553":"33e34ed7","644":"dfecaa69"}[chunkId] + ".chunk.js";
};